// src/data/contact.js

export const contact = {
  president: "Mr. Ramkrishna Mane",
  address:
    "2418, Mangalwar Peth, Tal: Karmala, District: Solapur, Maharashtra, India. Pincode - 413203",
  phone: "+91 9423334184",
  whatsapp: "+91 9423334184",
  email: "ramkrishnamane318@gmail.com", // optional, add if available
  map: "https://maps.google.com/?q=Mangalwar+Peth+Karmala+Solapur+Maharashtra+413203",
};

export const donation = {
  note:
    "Cheques should be made in the name of “Bhatake Vimukta Jati And Adivasi Dnyanpith Karmala” and can be sent to our address. As BVJAD is a registered public trust, you will receive a receipt for tax purposes through mail.",
  upiId: "shreyas.khadke@ybl", // keep or update
  bank: {
    accountName: "Bhatake Vimukta Jati And Adivasi Dnyanpith Karmala",
    accountNumber: "470501010012003", // replace with actual
    ifsc: "UBIN0547051", // replace with actual
    bankName: "Union Bank of India",
    branch: "Karmala",
  },

};